var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _vm.canJoin
        ? _c("join-request", {
            attrs: {
              name: "Group",
              "is-request-pending": _vm.viewer_state.is_join_request_pending,
              "request-pending-message": _vm.requestPendingMessage,
            },
            on: { join: _vm.onJoinAttempt },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.group.is_private
        ? _c(
            "story-list",
            {
              attrs: {
                "story-resource": _vm.GroupStoryResource,
                "target-id": _vm.targetId,
                "allow-add-content": false,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "alert alert-info",
                  attrs: { slot: "empty" },
                  slot: "empty",
                },
                [
                  _vm._v(
                    "There has been nothing added to this Group's story yet"
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }